import { useEffect, useState } from 'react'

/** Object URL for a File (e.g. image preview); revoked on change/unmount. */
export function useFileObjectUrl(file: File | null): string | undefined {
  const [url, setUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!file) {
      setUrl(undefined)
      return
    }
    const objectUrl = URL.createObjectURL(file)
    setUrl(objectUrl)
    return () => {
      URL.revokeObjectURL(objectUrl)
    }
  }, [file])

  return url
}
import { useEffect, useState } from 'react'

/** Object URL for a File (e.g. image preview); revoked on change/unmount. */
export function useFileObjectUrl(file: File | null): string | undefined {
  const [url, setUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!file) {
      setUrl(undefined)
      return
    }
    const objectUrl = URL.createObjectURL(file)
    setUrl(objectUrl)
    return () => {
      URL.revokeObjectURL(objectUrl)
    }
  }, [file])

  return url
}
